export const RECURRING_FREQUENCIES = [
  { id: 'weekly', label: 'Weekly', days: 7 },
  { id: 'monthly', label: 'Monthly', months: 1 },
  { id: 'quarterly', label: 'Quarterly', months: 3 },
  { id: 'annually', label: 'Annually', years: 1 }
];

export const SCHEDULE_STATUSES = {
  ACTIVE: { label: 'Active', color: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  PAUSED: { label: 'Paused', color: 'bg-amber-50 text-amber-700 border-amber-200' },
  EXPIRED: { label: 'Expired', color: 'bg-slate-100 text-slate-500 border-slate-200' }
};